<div (click)="toggle()" class="d-flex gap-3 m-1 p-2 rounded-2 pointer pointer-hover-blue background-light-gray align-items-center w-100">
    <div>
        <img src="icons/{{ icon() }}" class="icon"/>
    </div>
    <div class="d-flex align-items-center gap-1">
        <span class="fw-bold">{{ title() }}</span>
        <span class="flex-none" data-id="count">({{ animals().length }})</span>
    </div>
</div>
<div [ngClass]="{'collapse': !open}">
    @if (animals().length == 0) {
        <div class="text-center p-3 opacity-50">
            No animals
        </div>
    }
    @for (animal of animals(); track animal.id) {
        <div class="card mb-1 ms-1 me-1">
            <app-animal-button
                [id]="animal.id"
                [selectableForAlteration]="false"
                [selectableForDeletion]="false"
                [standalone]="false"/>
        </div>
    }
</div>
